import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import './Home.css';

// ─── Paste your YouTube showreel URL here ───────────────────────────────────
const SHOWREEL_URL = 'https://www.youtube.com/watch?v=fpIK1jMPEdQ';
// ────────────────────────────────────────────────────────────────────────────

function getYouTubeId(url) {
  const m = url.match(/(?:youtu\.be\/|v=|embed\/)([a-zA-Z0-9_-]{11})/);
  return m ? m[1] : null;
}

export default function Home() {
  const [projects, setProjects] = useState([]);
  const [playing, setPlaying] = useState(false);
  const iframeRef = useRef(null);
  const ytId = getYouTubeId(SHOWREEL_URL);

  useEffect(() => {
    supabase
      .from('projects')
      .select('*')
      .eq('featured', true)
      .order('sort_order')
      .limit(3)
      .then(({ data }) => data && setProjects(data));
  }, []);

  return (
    <main className="home">

      {/* ── Video Hero ── */}
      <section className="home__hero">
        <div className="home__video-wrap">

          {/* Thumbnail / cover shown before play */}
          {!playing && (
            <div className="home__video-cover" onClick={() => setPlaying(true)}>
              {ytId && (
                <img
                  className="home__video-thumb"
                  src={`https://img.youtube.com/vi/${ytId}/maxresdefault.jpg`}
                  alt="Showreel thumbnail"
                />
              )}
              <div className="home__video-overlay" />
              <button className="home__play-btn" aria-label="Play showreel">
                <span className="home__play-icon">▶</span>
                <span className="home__play-label">PLAY SHOWREEL</span>
              </button>
              <div className="home__hero-meta">
                <span className="home__hero-tag">BEST WORK — 2025</span>
              </div>
            </div>
          )}

          {/* YouTube iframe — mounts only after click */}
          {playing && ytId && (
            <iframe
              ref={iframeRef}
              className="home__video-iframe"
              src={`https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0&modestbranding=1&color=white`}
              title="MODAEDITZ Showreel"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}

          {/* Fallback when no URL is set yet */}
          {!ytId && (
            <div className="home__video-placeholder">
              <span>▶</span>
              <p>Set your YouTube URL in <code>Home.jsx → SHOWREEL_URL</code></p>
            </div>
          )}
        </div>

        {/* Info bar below video */}
        <div className="home__hero-bar">
          <div className="home__hero-info">
            <span className="home__hero-name">Karmakar <em>'Ashutosh'</em> </span>
            <span className="home__hero-role">Motion Designer · India</span>
          </div>
          <Link to="/work" className="home__hero-cta">VIEW ALL WORK ↗</Link>
        </div>
      </section>

      {/* ── Featured Work Grid ── */}
      <section className="home__work-teaser">
        <div className="home__work-header">
          <span className="home__section-label">SELECTED WORK</span>
          <Link to="/work" className="home__see-all">SEE ALL ↗</Link>
        </div>
        <div className="home__work-grid">
          {projects.length === 0
            ? [1, 2, 3].map(i => (
              <div key={i} className="home__work-placeholder">
                <div className="home__work-placeholder-inner" />
                <div className="home__work-placeholder-text" />
              </div>
            ))
            : projects.map(p => (
              <Link key={p.id} to={`/work/${p.id}`} className="home__work-item">
                <div className="home__work-thumb">
                  {p.thumbnail_url
                    ? <img src={p.thumbnail_url} alt={p.title} />
                    : <div className="home__work-thumb-empty"><span>▶</span></div>
                  }
                  <div className="home__work-hover">↗</div>
                </div>
                <div className="home__work-meta">
                  <span className="home__work-title">{p.title}</span>
                  <span className="home__work-cat">{p.category}</span>
                </div>
              </Link>
            ))
          }
        </div>
      </section>

      {/* ── About teaser ── */}
      <section className="home__about-teaser">
        <div className="home__about-content">
          <p className="home__about-label">FROM...</p>
          <div className="home__about-tags">
            {['Commercials', 'Short-form', 'Long-form'].map(tag => (
              <span key={tag} className="home__tag">› {tag}</span>
            ))}
          </div>
          <p className="home__about-tagline">
            ...I direct content that grows your brand.
          </p>
          <p className="home__about-cta">
            I love directing and editing brand contents.<br />
            <Link to="/contact" className="home__contact-link">
              Contact me to bring your ideas to life →
            </Link>
          </p>
        </div>
      </section>

      {/* ── Page nav ── */}
      <div className="home__page-nav">
        <span className="home__page-nav-item home__page-nav-item--disabled">← HOME</span>
        <Link to="/work" className="home__page-nav-item">WORK →</Link>
      </div>

    </main>
  );
}
